export enum GalleryViewTypes {
    InternalListings = 'internal-listings',
    ExternalListings = 'external-listings',
    RemovedListings = 'removed-listings',
    Folders = 'folders'
}